module.exports = __webpack_public_path__ + "img/3f_sense.9ebf0009.svg";